export const notDisplayedProperties = ["_id", "name", 'symbol', 'filtered'];
export const filterFunctions = { "name": function (elementValue, filterValue) {
        return elementValue.indexOf(filterValue) === -1;
    },
    "periodic_table": {
        "group": function (elementValue, filterValue) {
            return elementValue != filterValue;
        }
    }
};
export function getMass(element) {
    if ("mechanical" in element && "mass" in element.mechanical) {
        return element.mechanical.mass;
    }
    return "?";
}
